export default "assets/images/logo-ae5ba396.png";